import { h, FunctionComponent } from 'preact';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DocumentLink from '~src/domains/common/components/DocumentLink';
import { Doc } from '~src/domains/common/enums/docs';
import {
  brandSelector,
  commonDocsSelector,
} from '~src/domains/common/state/commonSelectors';
import { SessionType } from '~src/domains/common/types/api';
import * as styles from '~src/styles/domains/start/StartPage.module.scss';

const StartFootnotes: FunctionComponent = () => {
  const { t } = useTranslation();
  const commonDocs = useSelector(
    commonDocsSelector,
  ) as SessionType['common_docs'];
  const brand = useSelector(brandSelector);

  const getDocLink = (label: Doc) => {
    const commonDoc = commonDocs?.[label];
    if (commonDoc) {
      return (
        <DocumentLink
          id={label}
          text={t(`start:docs.${label}`)}
          url={commonDoc.url}
        />
      );
    }
  };

  const startDocs = {
    cipLink: getDocLink(Doc.CIP),
    cpaLink: getDocLink(Doc.CPA),
    esignLink: getDocLink(Doc.ESIGN),
    ppLink: getDocLink(Doc.PP),
    tosLink: getDocLink(Doc.TOS),
  };

  return (
    commonDocs && (
      <div className={styles['start-footnotes']}>
        <Trans
          t={t}
          i18nKey={`start:docs.${brand.toLowerCase()}.footnotes`}
          components={startDocs}
        />
      </div>
    )
  );
};

export default StartFootnotes;
